import BaseApi from './base'
class Ads extends BaseApi{
  constructor () {
    super()
  }
  
  handleSuccess (response) {
    return response
  }

  async getAdList (adPartyId, adDate, limit, offset) {
    const params = {
      ad_party_id: adPartyId,
      limit: limit,
      offset: offset
    }
    
    if (adDate) params.ad_date = adDate

    return await this.auth({
      url: '/ads',
      method: 'GET',
      params: params
    })
  }

  async getValidCopyDestinations ({ ad_id, feature_id, non_promo_only = false } = {}) {
    return await this.auth({
      url: `/ads/valid_copy_destinations/${ad_id}/${feature_id}`,
      method: 'GET',
      params: { non_promo_only }
    })
  }

  async getValidMassCopyDestinations (ad_id, feature_ids, non_promo_only = false) {
    return await this.auth({
      url: `/ads/valid_mass_copy_destinations/${ad_id}`,
      method: 'POST',
      params: { non_promo_only },
      data: { feature_ids }
    })
  }

  async getValidMoveDestinations ({ ad_id, feature_id, item_source, non_promo_only = false } = {}) {
    return await this.auth({
      url: `/ads/valid_move_destinations/${ad_id}/${feature_id}`,
      method: 'GET',
      params: { non_promo_only, item_source }
    })
  }

  async getValidMassMoveDestinations (ad_id, feature_ids) {
    return await this.auth({
      url: `/ads/valid_mass_move_destinations/${ad_id}`,
      method: 'POST',
      data: { feature_ids }
    })
  }

  async checkAdPromoGap ({ source_ad_id, start_date, end_date } = {}) {
    return this.auth({
      url: `/ads/check_promo_gap/${source_ad_id}`,
      method: 'GET',
      params: { start_date, end_date }
    })
  }

  async getAdById (adId) {
    return await this.auth({
      url: `/ad/${adId}`,
      method: 'GET'
    })
  }

  async getAdNotes (adId) {
    return await this.auth({
      url: `/ad_notes/${adId}`,
      method: 'GET'
    })
  }

  async saveAdNote (adNote) {
    return await this.auth({
      url: '/ad_note',
      method: 'POST',
      data:adNote
    })
  }

  async createAd (ad) {
    return await this.auth({
      url: '/ad',
      method: 'POST',
      data: ad
    })
  }

  async updateAd (adId, ad) {
    return await this.auth({
      url: `/ad/${adId}`,
      method: 'PUT',
      data: ad
    })
  }

  async deleteAd(adId){
    return await this.auth({
      url: `/ad/${adId}`,
      method: 'DELETE',
    })
  }

  async generateAdPlanFiles(adData) {
    return await this.auth({
      url: '/ad_plan_files',
      method: 'POST',
      data:adData
    })
  }

  async generateAdPlanner (adId, params, data){
    return await this.auth({
      url: `/ad_planner/${adId}`,
      method: 'POST',
      params: params,
      data: data
    })
  }

  async generateCSV (ad_id) {
    return await this.auth({
      url: `/ad_planner/csv/${ad_id}`,
      method: 'GET'
    })
  }

  async generateSystematicTxt(adData) {
    return await this.auth({
      url: `/ad_plan_files/adhoc-systematic`,
      method: 'POST',
      data:adData
    })
  }

  async downloadPDF (ad_id) {
    return await this.auth({
      url: `/ad_planner/pdf/${ad_id}`,
      method: 'GET'
    })
  }

  async shuttle(id, body){
    return await this.auth({
      url: `/ad/shuttle/${id}`,
      method:'POST',
      data:body
    })
  }

  async clone(id, body){
    return await this.auth({
      url:`/ad/clone/${id}`,
      method:'POST',
      data:body
    })
  }

  async checkAd(id){
    return await this.auth({
      url:`/ad/check_ad/${id}`,
      method:'GET'
    })
  }

  async shuttleHistory(id){
    return await this.auth({
      url:`/ad/shuttle_history/${id}`,
      method:'GET'
    })
  }

  async countItems(id){
    return await this.auth({
      url:`/ad/ad_item_count/${id}`,
      method:'GET'
    })
  }
  async search(id, params){
    return await this.auth({
      url:`/ad_planner/search/${id}`,
      method:'GET',
      params : params
    }
    ) 
  }

  async searchAll(params){
    return await this.auth({
      url:`/ad_planner/search`,
      method:'GET',
      params : params
    }
    ) 
  }

  async getShuttleAdGroups(ad_id, curr_ad_group_id) {
    return await this.auth({
      url: `/ad/ad_groups_to_shuttle/${ad_id}/${curr_ad_group_id}`,
      method:'GET',
    })
  }

  async getShipperComponents(ad_id, feature_id, params) {
    return await this.auth({
      url: `/ad_planner/shipper_components/${ad_id}/${feature_id}`,
      method: 'GET',
      params: params
    })
  }

  async publishAd (adId, params, data){
    return await this.auth({
      url: `/ad/publish/${adId}`,
      method: 'POST',
      params: params,
      data:data
    })
  }
}

export default new Ads()